<template>
  <button type="button" :class="classes" aria-disabled="true" @click="open">
    <i v-if="icon" :class="['mdi', icon, 'pb-ico']" aria-hidden="true"></i><span>{{ label }}</span> <span v-if="cap" class="pb-lock-cap">{{ cap }}</span> <PlanChip :plan="plan" />
  </button>
</template>

<script>
import PlanChip from './PlanChip.vue';
import { showUpgrade } from '../lib/upgrades';

// An action the plan doesn't include, shown where it would be used: it stays focusable (aria-disabled, never
// `disabled`), reads "Available on Agency", and a click explains the feature and offers the plan.
export default {
  name: 'LockedAction',
  components: { PlanChip },
  props: {
    // The policy.LIMITS key (lib/plans.js LOCKED_FEATURES).
    feature: { type: String, required: true },
    label: { type: String, required: true },
    icon: { type: String, default: '' },
    // The classes of the control it stands in for: a button, or an item in a menu.
    look: { type: String, default: 'pb-button outline' },
    // A capped create action shows its cap ("1 of 1 on Free") and opens the dialog with the count.
    cap: { type: String, default: '' },
    used: { type: Number, default: null }
  },
  computed: {
    plan() { return this.$store.getters['praiseboard/availableOn'](this.feature) || ''; },
    classes() { return this.look.split(' ').concat(['is-locked']); }
  },
  methods: {
    // The app's upgrade dialog opens, unless the parent listens to `upgrade` to open its own (stacked over a dialog).
    open() {
      const detail = this.used === null ? { feature: this.feature } : { feature: this.feature, used: this.used };
      this.$emit('locked', detail);
      if (this.$listeners.upgrade) this.$emit('upgrade', detail); else showUpgrade(detail);
    }
  }
};
</script>
